<template>
  <div class="p-tasklist-proposal__content">
    <FormProposal
      :checked="params.checked"
      :project="project"
      :total="data.items.length"
      :type="type"
      @submit="submit"
    />
    <VirtualList :items="sortedItems" :itemSize="itemSize" ref="list">
      <template slot="header">
        <div class="c-virtual-list__head">
          <div class="c-virtual-list__col check" @click.prevent="clickCheckAll">
            <Checkbox
              v-if="data.items.length"
              :checked="params.checkedAll"
              :id="type + '_all'"
              :name="type + '_all'"
              ref="checkbox"
              @change="changeCheckAll"
            />
          </div>
          <template v-if="isChangeTd || isRewrite">
            <ThSort
              v-model="params.sort[type]"
              name="keyword"
              orderby="asc"
              tag="div"
              type="string"
              class="c-virtual-list__col keyword"
            >
              キーワード
            </ThSort>
            <ThSort
              v-model="params.sort[type]"
              name="rank"
              orderby="desc"
              tag="div"
              type="number"
              class="c-virtual-list__col rank"
            >
              平均順位
            </ThSort>
            <ThSort
              v-model="params.sort[type]"
              name="searchVolume"
              orderby="desc"
              tag="div"
              type="number"
              class="c-virtual-list__col searchVolume"
            >
              月間検索数
            </ThSort>
            <ThSort
              v-model="params.sort[type]"
              name="impressions"
              orderby="desc"
              tag="div"
              type="number"
              class="c-virtual-list__col impressions"
            >
              表示回数
            </ThSort>
            <ThSort
              v-model="params.sort[type]"
              name="ctr"
              orderby="desc"
              tag="div"
              type="number"
              class="c-virtual-list__col ctr"
            >
              クリック率
            </ThSort>
            <ThSort
              v-model="params.sort[type]"
              name="influx"
              orderby="desc"
              tag="div"
              type="number"
              class="c-virtual-list__col influx"
            >
              流入数
            </ThSort>
            <ThSort
              v-model="params.sort[type]"
              name="url"
              orderby="asc"
              tag="div"
              type="string"
              class="c-virtual-list__col url"
            >
              流入先URL
            </ThSort>
            <ThSort
              v-model="params.sort[type]"
              name="title"
              orderby="asc"
              tag="div"
              type="string"
              class="c-virtual-list__col title"
            >
              タイトル
            </ThSort>
          </template>
          <template v-else-if="isCreateContent">
            <ThSort
              v-model="params.sort[type]"
              name="keyword"
              orderby="asc"
              tag="div"
              type="string"
              class="c-virtual-list__col keyword"
            >
              キーワード
            </ThSort>
            <ThSort
              v-model="params.sort[type]"
              name="rank"
              orderby="asc"
              tag="div"
              type="number"
              class="c-virtual-list__col rank"
            >
              順位
            </ThSort>
            <ThSort
              v-model="params.sort[type]"
              name="searchVolume"
              orderby="desc"
              tag="div"
              type="number"
              class="c-virtual-list__col searchVolume"
            >
              月間検索数
            </ThSort>
            <ThSort
              v-model="params.sort[type]"
              name="url"
              orderby="asc"
              tag="div"
              type="string"
              class="c-virtual-list__col url"
            >
              URL
            </ThSort>
            <ThSort
              v-model="params.sort[type]"
              name="title"
              orderby="asc"
              tag="div"
              type="string"
              class="c-virtual-list__col title"
            >
              タイトル
            </ThSort>
          </template>
        </div>
      </template>
      <template slot="before">
        <div v-if="isLoading" class="c-virtual-list__guide">
          <div class="c-virtual-list__col l-p-0">
            <LoadingChara variant="inline">
              <template slot="title">
                データ取得中
              </template>
            </LoadingChara>
          </div>
        </div>
        <div v-else-if="!data.items.length" class="c-virtual-list__guide">
          <div class="c-virtual-list__col l-p-0">
            <Error img="task" variant="inline">
              <template slot="title">
                改善提案はありません。
              </template>
            </Error>
          </div>
        </div>
      </template>
      <template v-slot="{ item }">
        <ListItemProposal
          v-model="params.checked"
          :key="item.id"
          :item="item"
          :project="project"
          :type="type"
        />
      </template>
    </VirtualList>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox';
import Error from '@/components/Error';
import FormProposal from '@/components/taskList/FormProposal';
import ListItemProposal from '@/components/taskList/ListItemProposal';
import LoadingChara from '@/components/LoadingChara';
import ThSort from '@/components/ThSort';
import VirtualList from '@/components/VirtualList';
import apiProjects from '@/api/projects';
import utils from '@/utils';

export default {
  props: {
    project: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  components: {
    Checkbox,
    Error,
    FormProposal,
    ListItemProposal,
    LoadingChara,
    ThSort,
    VirtualList
  },
  data() {
    return {
      data: {
        items: []
      },
      itemSize: 37,
      params: {
        checked: [],
        checkedAll: false,
        sort: {
          changeTd: {
            name: 'ctr',
            orderby: 'asc',
            type: 'number'
          },
          rewrite: {
            name: 'searchVolume',
            orderby: 'desc',
            type: 'number'
          },
          createContent: {
            name: 'searchVolume',
            orderby: 'desc',
            type: 'number'
          }
        }
      },
      isLoading: true
    };
  },
  computed: {
    sortedItems() {
      let items = this.data.items.slice();
      return utils.sort(
        items,
        this.params.sort[this.type].type,
        this.params.sort[this.type].orderby,
        this.params.sort[this.type].name
      );
    },
    isCreateContent() {
      return this.type === 'createContent';
    },
    isChangeTd() {
      return this.type === 'changeTd';
    },
    isRewrite() {
      return this.type === 'rewrite';
    }
  },
  watch: {
    'params.checked': {
      handler(value) {
        if (!value.length) {
          this.params.checkedAll = false;
        }
      }
    },
    'params.sort': {
      handler() {
        this.$nextTick(() => {
          this.$refs.list.scrollToStart();
        });
      },
      deep: true
    }
  },
  created() {
    this.getProposals();
  },
  methods: {
    getProposals() {
      const params = {
        date: this.$options.filters.dateText(utils.getDateResetHours()),
        limit: this.isCreateContent ? 500 : 100,
        type: this.type
      };
      return apiProjects.proposals
        .get(params, this.auth.idToken, this.project.id)
        .then(response => {
          this.data.items = response.data.items;
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
        });
    },
    submit(item) {
      const itemIndex = this.data.items.indexOf(item);
      if (itemIndex !== -1) {
        this.data.items.splice(itemIndex, 1);
      }
      const checkedIndex = this.params.checked.indexOf(item);
      if (checkedIndex !== -1) {
        this.params.checked.splice(checkedIndex, 1);
      }
    },
    clickCheckAll() {
      if (!this.$refs.checkbox) {
        return;
      }
      this.$refs.checkbox.change();
    },
    changeCheckAll(checked) {
      this.params.checkedAll = checked;
      if (checked) {
        this.checkAll();
      } else {
        this.uncheckAll();
      }
    },
    checkAll() {
      this.params.checked = this.data.items.slice();
    },
    uncheckAll() {
      this.params.checked = [];
    }
  }
};
</script>
